import type { components } from "@/types/api.generated";
import apiClient from "./client";

/**
 * Usuários do Digital Access e a decisão por usuário (#1346, EF-FUNC-005 RF-06).
 *
 * Aliases sobre os tipos gerados do OpenAPI: o contrato mora no backend
 * (`routers/digital_access.py`, fatia 7).
 */
export type DigitalAccessUser = components["schemas"]["DigitalAccessUser"];
export type DigitalAccessUsers = components["schemas"]["DigitalAccessUsers"];
export type DigitalAccessDecisionUpdate = components["schemas"]["DigitalAccessDecisionUpdate"];
export type DigitalAccessDecisionResult = components["schemas"]["DigitalAccessDecisionResult"];
/** `include`, `exclude` ou `client_validation`; sem decisão vale a regra da EF. */
export type DigitalAccessDecisionValue = NonNullable<DigitalAccessUser["decision"]>;

/**
 * `GET /api/projects/{projectId}/digital-access/users`.
 *
 * Projeto sem execução que tenha contado por usuário responde 200 com a lista vazia.
 */
export async function getDigitalAccessUsers(projectId: string): Promise<DigitalAccessUsers> {
  const res = await apiClient.get<DigitalAccessUsers>(
    `/api/projects/${projectId}/digital-access/users`,
  );
  return res.data;
}

/**
 * `PUT /api/projects/{projectId}/digital-access/users/{username}/decision`.
 *
 * `decision: null` volta à regra da EF. Incluir ou excluir sem justificativa é 422;
 * decisão mudada por outra pessoa desde a leitura (`expected_version`) é 409.
 */
export async function putDigitalAccessDecision(
  projectId: string,
  username: string,
  body: DigitalAccessDecisionUpdate,
): Promise<DigitalAccessDecisionResult> {
  const res = await apiClient.put<DigitalAccessDecisionResult>(
    `/api/projects/${projectId}/digital-access/users/${encodeURIComponent(username)}/decision`,
    body,
  );
  return res.data;
}

export type DigitalAccessCoverage = components["schemas"]["DigitalAccessCoverage"];

/**
 * `GET /api/projects/{projectId}/digital-access/coverage` (#1346, fatia 11).
 *
 * A estimativa, já com as decisões por usuário, contra a BOM vigente: franquia,
 * blocos contratados, gap, blocos sugeridos e status. Sem contagem por usuário,
 * `state` diz por quê.
 */
export async function getDigitalAccessCoverage(projectId: string): Promise<DigitalAccessCoverage> {
  const res = await apiClient.get<DigitalAccessCoverage>(`/api/projects/${projectId}/digital-access/coverage`);
  return res.data;
}
